import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { goToCheckout } from '../lib/constants';

/**
 * Floating CTA that appears only after the user scrolls past the
 * first hero CTA button (identified by #hero-cta).
 */
export function FloatingCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const target = document.getElementById('hero-cta');
    if (!target) return;

    // Embedded or older browsers may not expose IntersectionObserver.
    // The CTA remains non-blocking instead of crashing the rendered page.
    if (!('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver(([entry]) => {
      // Show once the hero CTA has scrolled out of view (upwards)
      setVisible(!entry.isIntersecting && entry.boundingClientRect.top < 0);
    }, {
      threshold: 0
    });
    observer.observe(target);
    return () => observer.disconnect();
  }, []);
  return <AnimatePresence data-id="element-110" data-mp="2b2p8g0fpu2fc">
      {visible && <motion.div initial={{
      y: 120,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 120,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 260,
      damping: 26
    }} className="fixed inset-x-0 bottom-0 z-50 px-3 pb-3" data-id="element-111" data-mp="2b3qji4wqeox2">
          <div className="mx-auto max-w-md" data-id="element-112" data-mp="26ap4lwwiypdh">
            <motion.button type="button" onClick={goToCheckout} whileTap={{
          scale: 0.97
        }} className="flex w-full items-center justify-center gap-2 rounded-2xl bg-mauve px-4 py-3.5 text-sm font-extrabold text-white shadow-[0_-6px_24px_-4px_rgba(74,47,69,0.45)] ring-2 ring-white/40 sm:text-base" data-id="element-113" data-mp="269dyhqflx5j7">
              <span data-id="element-114" data-mp="1ndefv68ireca">🧶 QUIERO EL SISTEMA</span>
              <span className="rounded-full bg-white/20 px-2 py-0.5 text-xs font-bold" data-id="element-115" data-mp="3crsxz7p182yt">
                $12.99
              </span>
            </motion.button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}